import { http } from '@/services/api/client';
import type { LoginPayload, LoginResult, RefreshTokenPayload } from '@/types/auth';

export async function login(payload: LoginPayload): Promise<LoginResult> {
  return http.post('/auth/wechat-phone-login', payload) as Promise<LoginResult>;
}

export async function refreshToken(payload: RefreshTokenPayload): Promise<LoginResult> {
  return http.post('/auth/refresh-token', payload) as Promise<LoginResult>;
}

export async function logout(): Promise<{ success: true }> {
  return http.post('/auth/logout') as Promise<{ success: true }>;
}
